import { createDinero } from '@mr-yum/frontend-core/dist/services/createDinero'
import React from 'react'
import { FormattedMessage } from 'react-intl'

interface Props {
  subTotalInCents: number
  currency: string
}

export const CartSubTotal = ({ subTotalInCents, currency }: Props) => {
  return (
    <div className="flex items-baseline justify-between">
      <div className="my-body-md">
        <FormattedMessage
          description="The subtotal amount of the cart"
          defaultMessage="Subtotal"
          id="RmbokN"
        />
      </div>
      <div data-testid="subtotal" className="my-body-md">
        {createDinero(subTotalInCents, currency).toFormat()}
      </div>
    </div>
  )
}
